// https://blog.logrocket.com/developing-responsive-layouts-with-react-hooks/

import React from 'react'
import { viewportBreakpoint } from './viewport-breakpoint';
import { viewportContext } from './viewport-context';

const useViewport = () => {
  const { width, height } = React.useContext(viewportContext);
  const isMobile = width < viewportBreakpoint.tablet
  const isTablet = width >= viewportBreakpoint.tablet && width < viewportBreakpoint.desktop
  const isDesktop = width >= viewportBreakpoint.desktop
  return { width, height, isMobile, isTablet, isDesktop };
}

export { useViewport }
